import {createFileRoute} from '@tanstack/react-router';

import DiagnosticReportRequest from '@/patient/views/DiagnosticReportRequest';

export const Route = createFileRoute('/(patient)/patient/diagnostic-report-request')({
  component: DiagnosticReportRequest
});
